const url = '/api/v1/'

export const state = {
    user: {},
}

export const getters = {
    user: state => state.user,
}

export const mutations = {
    setUser(state, user) {
        state.user = user
    },
}

export const actions = {
    async restorePassword({commit, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.post(url + 'restore-password', params);
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res);
    },

    async newPassword({commit, dispatch}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.post(url + 'new-password', params);
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res.data);
    },

    async getUser({commit, dispatch}) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.get(url + 'get-user');
        commit('setUser', res.data.user)
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res.data);
    },

    async getStudent({commit, dispatch}) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.get(url + 'student/get-user');
        commit('setUser', res.data.user)
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res.data);
    },

    hasRole({state, dispatch}, role) {
        if (state.user.roles) {
            return !!(state.user.roles.find(({name}) => name === role));
        }

        return null;
    }
}
